<template>
    <div class="loader-overlay" v-if="$loader.displayed" @click.prevent.stop="">
        <div class="centered">
            <div class="spinner"><div></div><div></div></div>
        </div>
    </div>
</template>

<script>
    export default {
    };
</script>

<style scoped>

    .loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 2000;
        background-color: rgb(0, 0, 0, 0.5);
        overflow-x: hidden;
        overflow-y: hidden;
    }
    .centered {
        position:absolute;
        top: 50%;
        left:50%;
        margin-top: -50px;
        margin-left: -50px;
    }
    .spinner {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .spinner div {
        position: absolute;
        border: 4px solid #fff;
        opacity: 1;
        border-radius: 50%;
        animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
    }
    .spinner div:nth-child(2) {
        animation-delay: -0.5s;
    }
    @keyframes lds-ripple {
        0% {
            top: 36px;
            left: 36px;
            width: 0;
            height: 0;
            opacity: 1;
        }
        100% {
            top: 0px;
            left: 0px;
            width: 72px;
            height: 72px;
            opacity: 0;
        }
    }

</style>